import React, { useCallback, useEffect, useState } from 'react';
import OrderPreferencesModule from '../../../components/OrderPreferencesModule';
import ClientButton from '../../../components/ClientButton';
import ModalWithHeadingSmall from '../../../components/ModalWithHeadingSmall';
import { slugFormatter, titleCaseFormatter } from '../../../utils/stringFormatters';
import { getOrderPreferencesApi, updateOrderPreferencesApi } from '../../../redux/Reducers/MyAccountReducer';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-hot-toast';
import { isEmpty } from 'lodash';
import { setPreferencesLoadingAction } from '../../../redux/Actions/MyOrdersActions';
import Loader from '../../../components/Loader';
import ModalBasic from '../../../components/Modal';
import Button from '../../../components/Button';
export default function OrderPreferencesModal({ modalOpen, setModalOpen }) {
  const dispatch = useDispatch();
  const { selectedAddress } = useSelector((state) => state.serviceAddresses);
  const { orderPreferences, preferencesLoading } = useSelector((state) => state.myaccount);
  const [builtPreferences, setBuiltPreferences] = useState(
    orderPreferences?.preference || orderPreferences?.preferences || null
  );
  useEffect(() => {
    setBuiltPreferences(orderPreferences?.preference || orderPreferences?.preferences || null);
  }, [orderPreferences]);

  const updatePreferencesFn = (payload) => {
    dispatch(setPreferencesLoadingAction(true));
    const response = updateOrderPreferencesApi(selectedAddress?.id, payload);
    response?.then((res) => {
      if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
        toast.success(res?.message || 'Order preferences updated successfully');
        selectedAddress && dispatch(getOrderPreferencesApi(selectedAddress?.id));
        setModalOpen(false);
        dispatch(setPreferencesLoadingAction(false));
      } else {
        dispatch(setPreferencesLoadingAction(false));
        toast.error(res?.message || 'Something went wrong');
      }
    });
  };
  const onOrderPreferencesSaveFn = () => {
    // validation: if pickup_delivery is 'other', require instructions >= 5 chars
    const pickupVal = String(builtPreferences?.pickup_delivery || '')
      .trim()
      .toLowerCase();
    const instructions = String(builtPreferences?.pickup_delivery_instructions || '').trim();
    if (pickupVal === 'other' && (!instructions || instructions.length < 5)) {
      return;
    }
    if (pickupVal !== 'other') {
      delete builtPreferences.pickup_delivery_instructions;
    }
    const payload = {
      preferences: builtPreferences || {},
    };
    updatePreferencesFn(payload);
  };
  useEffect(() => {
    selectedAddress && dispatch(getOrderPreferencesApi(selectedAddress?.id));
  }, [selectedAddress]);

  return (
    <ModalBasic
      id='order-preferences-modal'
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      title={'Order Preferences'}
      width='4xl'
    >
      <div className=''>
        <div className='z-0 rounded-lg bg-white '>
          <p className='text-client-cancelled go-text-16 mb-4 px-5'>
            Please note: This change will not update the preferences of your current orders.
          </p>
          <OrderPreferencesModule
            type={'edit'}
            preferences={orderPreferences?.preference || orderPreferences?.preferences}
            update={(obj) => setBuiltPreferences(obj)}
            loader={preferencesLoading}
          />

          <div className='mx-auto flex max-w-md justify-center space-x-4 p-4'>
            <Button variant='secondary' text='Cancel' classes='w-full' onClick={() => setModalOpen(false)} />
            <Button variant='primary-dark' text='Save' classes='w-full' onClick={() => onOrderPreferencesSaveFn()} />
          </div>
        </div>
        {/* <div className='py-4'>
          <ModalWithHeadingSmall
            modalOpen={notifyModal}
            setModalOpen={setNotifyModal}
            title='Please note: This change will not update the preferences of your current orders.'
            classes='max-w-2xl py-10'
          >
            <div className='mx-8'>
              <div className='flex-col justify-center py-5 text-center '>
                <ClientButton
                  variant='primary'
                  text='Close'
                  classes=''
                  onClick={() => {
                    setNotifyModal(false);
                  }}
                />
              </div>
            </div>
          </ModalWithHeadingSmall>
        </div> */}
      </div>
    </ModalBasic>
  );
}
